import AsyncStorage from '@react-native-async-storage/async-storage';

export type FontFamilyOption = 'serif' | 'outfit' | 'poppins';
export type FontSizeOption = 'small' | 'medium' | 'large' | 'huge';

export interface ReadingSettings {
  fontFamily: FontFamilyOption;
  fontSize: FontSizeOption;
}

const KEY_PREFIX = '@mentorist_reading_';
const KEY_SETTINGS = `${KEY_PREFIX}settings`;

export const defaultReadingSettings: ReadingSettings = {
  fontFamily: 'outfit',  // Default to Outfit for clean reading experience
  fontSize: 'medium',
};

export async function getReadingSettings(): Promise<ReadingSettings> {
  try {
    const raw = await AsyncStorage.getItem(KEY_SETTINGS);
    if (!raw) return defaultReadingSettings;
    const parsed = JSON.parse(raw);
    return {
      ...defaultReadingSettings,
      ...parsed,
    } as ReadingSettings;
  } catch (e) {
    return defaultReadingSettings;
  }
}

export async function setReadingSettings(settings: ReadingSettings): Promise<void> {
  try {
    await AsyncStorage.setItem(KEY_SETTINGS, JSON.stringify(settings));
  } catch {}
}


